import React, { useEffect } from 'react';
import { tokens } from '../theme';

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  width?: number;
  children: React.ReactNode;
}

export function Modal({ open, onClose, title, width = 640, children }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(22,30,41,0.6)',
        backdropFilter: 'blur(12px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: width,
          maxHeight: '80vh',
          overflowY: 'auto',
          background: tokens.color.paper['00'],
          borderRadius: tokens.radius.lg,
          padding: 32,
        }}
      >
        {title && (
          <h2
            style={{
              fontFamily: tokens.font.display,
              fontSize: 28,
              fontWeight: 400,
              marginBottom: 24,
              color: tokens.color.ink[900],
            }}
          >
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>
  );
}
